import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as Search } from '../../assets/images/svg/search.svg';
import themeColors from '../../assets/styles/themeColors';

const SearchIconStyled = styled(Search)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorTextXLLight};
`;

const SearchIcon = (props) => <SearchIconStyled {...props} />;

SearchIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

SearchIcon.defaultProps = {
  w: '20px',
  h: '20px',
};

export default SearchIcon;
